import React from "react";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import SandboxedEmail from "../SandboxedEmail";

const WebmailDetail = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const selectedMail = location?.state?.selectedMail;

    if (!selectedMail) {
        return (
            <div className="p-6 text-center text-sm text-gray-400">
                <p>No email selected.</p>
                <button className="imap-btn-secondary mt-3" onClick={() => navigate(-1)}>
                    <FiArrowLeft size={14} style={{ marginRight: "6px", verticalAlign: "middle" }} />
                    Back
                </button>
            </div>
        );
    }

    const sender = selectedMail?.sentBy || selectedMail?.from || selectedMail?.name || "";
    const avatarLetter = (selectedMail?.name || sender || "?").trim().charAt(0).toUpperCase();
    const date = selectedMail?.createdAtEmail || selectedMail?.date || selectedMail?.createdAt;

    return (
        <div className="relative bg-[#fff]">
            <div style={{ padding: "10px 16px 0" }}>
                <button
                    type="button"
                    className="imap-icon-btn-back"
                    onClick={() => navigate(-1)}
                    aria-label="Back"
                    title="Back"
                >
                    <FiArrowLeft size={16} />
                </button>
            </div>
            <div className="mail-inBox-header mail-reading-header">
                <div className="mail-reading-subject-row">
                    <h1 className="mail-reading-subject">{selectedMail?.subject || "(No subject)"}</h1>
                </div>
            </div>

            <div className="conversation-box mail-reading-conversation relative bg-white">
                <div className="mail-reading-message">
                    <div className="mail-reading-message-header">
                        <div className="mail-reading-message-header-left">
                            <div className="mail-reading-avatar">{avatarLetter}</div>
                            <div className="mail-reading-meta">
                                <span className="mail-reading-sender">{sender}</span>
                                <span className="mail-reading-recipients">
                                    {selectedMail?.sentTo && (
                                        <>
                                            <span className="mail-reading-recipients-label">To</span>
                                            {selectedMail.sentTo}
                                        </>
                                    )}
                                    {selectedMail?.cc && <>, cc: {selectedMail.cc}</>}
                                    {selectedMail?.bcc && <>, bcc: {selectedMail.bcc}</>}
                                </span>
                            </div>
                        </div>
                        <div style={{ fontSize: "12px", color: "#9ca3af", whiteSpace: "nowrap" }}>
                            {date ? moment(date).format("MMM DD, YYYY h:mm A") : ""}
                        </div>
                    </div>

                    <div className="mail-reading-body" style={{ padding: "12px 16px" }}>
                        <SandboxedEmail html={selectedMail?.body} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WebmailDetail;
